// Router for the `when` consumer app. Public: Landing, AuthCallback, Invite,
// Respond (/p/:token magic-link — the token is the credential).
// Protected (require a session): Home, Overlap, Propose.
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { Screen, Spinner } from './components/ui';
import Landing from './pages/Landing';
import AuthCallback from './pages/AuthCallback';
import Invite from './pages/Invite';
import Home from './pages/Home';
import Overlap from './pages/Overlap';
import Propose from './pages/Propose';
import Respond from './pages/Respond';
import ConnectCalendar from './pages/ConnectCalendar';

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Screen><Spinner /></Screen>;
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/?next=${next}`} replace />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/i/:token" element={<Invite />} />
      <Route path="/p/:token" element={<Respond />} />
      <Route path="/home" element={<Protected><Home /></Protected>} />
      <Route path="/connect" element={<Protected><ConnectCalendar /></Protected>} />
      <Route path="/with/:principalId" element={<Protected><Overlap /></Protected>} />
      <Route path="/with/:principalId/propose" element={<Protected><Propose /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
